import { Component, OnInit, ViewChild } from '@angular/core';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import {TreeNode} from 'primeng/api';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { AddNewStepModalComponent } from './add-new-step-modal/add-new-step-modal.component';
import { InitStepDetailsComponent } from './init-step-details/init-step-details.component';
import { StepDetailsComponent } from './step-details/step-details.component';
import { StepCompletionDetailsComponent } from './step-completion-details/step-completion-details.component';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';

@Component({
  selector: 'app-multi-steps-tree',
  templateUrl: './multi-steps-tree.component.html',
  styleUrls: ['./multi-steps-tree.component.scss']
})
export class MultiStepsTreeComponent implements OnInit {

  @ViewChild('addNewStepComponent', { static: true }) addNewStepComponent: AddNewStepModalComponent;
  @ViewChild('initStepDetails', { static: true }) initStepDetails: InitStepDetailsComponent;
  @ViewChild('stepDetails', { static: true }) stepDetails: StepDetailsComponent;
  @ViewChild('stepCompletionDetails', { static: true }) stepCompletionDetails: StepCompletionDetailsComponent;

  tree: TreeNode[] = [];
  selectedNode: TreeNode;

  constructor( private workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService,
     private _router: Router, private ecoDocsTitleService: EcoDocsTitleService) {
  }
  
  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Workflow Wizard > Tree Editor', false );
    

    if(this.workflowWizardService.workflowTemplateFormGroup.value)
      this.refreshTree();

    this.workflowWizardService.onInit.subscribe(() => {
      if(this.workflowWizardService.currentId == 'new' && this.workflowWizardService.currentStepURL != this.workflowWizardService.WIZARD_STEPS_TREE) {
        this._router.navigate([this.workflowWizardService.baseURL + this.workflowWizardService.WIZARD_FIRST_STEP]); 
      }
      this.refreshTree();
    });
  }

  showAddStepModal(stepCompletion: FormGroup) {
    this.addNewStepComponent.show(stepCompletion);
  }

  onStepAdded() {
    this.refreshTree();
  }

  addNewDecisionToStep(stepFormGroup: FormGroup) {
    this.workflowTemplateService.addNewStepCompletionToStep(stepFormGroup);
    this.goToStep(stepFormGroup);
  }

  clearNodeSelection() {
    this.selectedNode = [] as TreeNode;
  }

  saveWorkflow() {
    this.workflowWizardService.saveWorkflowTemplate().subscribe((workflowTemplate)=> {
      this.refreshTree();
    });
  }

  saveAndPublish() {
    this.workflowWizardService.saveWorkflowTemplate().subscribe(()=>{
      this.workflowWizardService.publishWorkflowTemplate().subscribe(()=>{
        this._router.navigate(['workflows/templates']);
      });
    });
  }

  onNodeUnselect() {
    this.initStepDetails.hide();
    this.stepDetails.hide();
    this.stepCompletionDetails.hide();
  }

  refreshTree() {
    this.tree = this.workflowWizardService.convertWorkflowFullTreeToPrimeTree();
  }

  goToInitialStepCompletion() {
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_FIRST_STEP}`);
  }
  goToStep(stepFormGroup) {
    this.workflowWizardService.currentStep = stepFormGroup;
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP;
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP}`);
  }

  selectNode($event: any) {
    if ($event.node.data.initial_step_completion) {
      this.stepCompletionDetails.hide();
      this.stepDetails.hide();
      this.initStepDetails.show();
    }
    else if ($event.node.data.step) {
      this.stepCompletionDetails.hide();
      this.initStepDetails.hide();
      this.stepDetails.show($event.node.data.step);
    }
    else {
      this.stepDetails.hide();
      this.initStepDetails.hide();
      this.stepCompletionDetails.show($event.node.data.step_completion);
    }
  }

}
